import React from 'react';
import { Box, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import {
  COLOR_WHITE,
  FONT_SIZE_10_PX,
  FONT_SIZE_13_PX,
  FONT_SIZE_16_PX,
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_NORMAL,
} from 'popTheme';

export const TabItem = ({ icon, index, label, language, totalItems }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: '0.75rem', md: FONT_SIZE_16_PX },
        color: COLOR_WHITE,
        opacity: 0.25,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          height: { xs: '3.25rem', md: '3.75rem' },
          gap: { xs: FONT_SIZE_16_PX, md: '1.25rem' },
        }}
      >
        <Box data-testid="tab-item-icon">{icon}</Box>
        <Box
          fontWeight={FONT_WEIGHT_BOLD}
          fontSize={{ xs: FONT_SIZE_16_PX, md: '1.25rem' }}
          textAlign="center"
        >
          {label}
        </Box>
      </Box>
      <Box
        alignItems="flex-start"
        textAlign="center"
        fontWeight={FONT_WEIGHT_NORMAL}
        pb={FONT_SIZE_16_PX}
        fontSize={FONT_SIZE_10_PX}
        borderBottom={`0.125rem solid ${COLOR_WHITE}`}
        sx={{
          [theme.breakpoints.up('xs')]: {
            width: '9.375rem',
          },
          [theme.breakpoints.up('sm')]: {
            width: '9.75rem',
          },
          [theme.breakpoints.up('md')]: {
            width: '12.5rem',
            fontSize: FONT_SIZE_13_PX,
          },
          [theme.breakpoints.up('lg')]: {
            width: '18.75rem',
          },
        }}
      >
        <span>{index}</span>
        <span> {language === 'FRENCH' ? 'de' : 'of'} </span>
        <span>{totalItems}</span>
      </Box>
    </Box>
  );
};

TabItem.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string.isRequired,
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  totalItems: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};
